<script setup>
import { ref } from "vue";
import Icon from "../../Common/Icon.vue";

const isOpen = ref(false);
</script>

<template>
  <div>
    <button
      type="button"
      @click="isOpen = !isOpen"
      class="border-b w-full border-dark/10 py-5 lg:py-6 flex items-center justify-between px-10 lg:px-16"
    >
      <div>
        <slot name="header"></slot>
      </div>
      <Icon name="caret-down" :class="isOpen ? 'rotate-180' : ''" class="size-4 shrink-0 transition-transform" />
    </button>

    <div
      :class="isOpen ? 'grid-rows-accordion-open' : 'grid-rows-accordion-close'"
      class="content grid transition-accordion"
    >
      <div class="overflow-hidden">
        <div class="border-b border-dark/10">
          <slot name="inner"></slot>
        </div>
      </div>
    </div>
  </div>
</template>
